import React from "react";
import DocIcon from "!svg-inline-loader!./images/doc.svg";
import SvgInline from "../SvgInline";

const StubImage = () => {
  return (
    <div className="teaser__stub-image">
      <SvgInline src={DocIcon} className="teaser__stub-ico" />
    </div>
  );
};

export default StubImage;
